<template>
  <ion-page>
    <ion-content class="main-background" :fullscreen="true" slot="fixed" :scroll-y="false">
      <div class="offline-backdrop" v-show="showOfflineSelector"></div>

      <div class="top-safe-area"></div>
        <ion-button v-on:click="returnBack(prevRouteName)" class="header-sm-button bg-transparent top-level white-regular">
        <ion-icon slot="start" :icon="arrowBackOutline"></ion-icon>
      </ion-button>

      <ion-button v-on:click="returnBack('Showcase')"
        class="header-sm-button header-sm-button-right bg-transparent top-level white-regular">
        <ion-icon slot="end" :icon="homeOutline"></ion-icon>
      </ion-button>

      <div class="offline-select-container" v-show="showOfflineSelector">
        <ion-list lines="none">
          <div class="offline-select-header">
            <ion-icon :icon="close" v-show="!isDownloading" class="close-icon" @click="hideOfflineSelector()"></ion-icon>
          </div>
          <ion-list-header>
            <ion-label>Оффлайн доступ</ion-label>
          </ion-list-header>
          <ion-item :class="[
            'online-item',
            releaseEntity.musicOffline &&
              !downloadProgress.get('music')?.downloading &&
              !preparingDownload.get('music')
              ? 'offline-item'
              : '',
          ]" button @click="handleEntityClick('music')" :disabled="downloadProgress.get('music')?.downloading">
            <ion-label>Музыка</ion-label>
            <ion-text slot="end" v-show="downloadProgress.get('music')?.downloading">
              {{ downloadProgress.get("music")?.percentage }}%
            </ion-text>
            <ion-spinner slot="end" v-show="preparingDownload.get('music') && !downloadProgress.get('music')?.downloading" name="crescent"></ion-spinner>
            <ion-icon :icon="cloudDownloadOutline" slot="end" v-show="!releaseEntity.musicOffline &&
              !downloadProgress.get('music')?.downloading &&
              !preparingDownload.get('music')
              "></ion-icon>
            <ion-icon :icon="stopCircle" slot="end" v-show="downloadProgress.get('music')?.downloading"
              @click.stop="stopDownload('music')"></ion-icon>
            <ion-icon :icon="trash" slot="end" v-show="!downloadProgress.get('music')?.downloading &&
              !preparingDownload.get('music') &&
              releaseEntity.musicOffline
              " @click.stop="removeReleaseEntityDirectory('music')"></ion-icon>
            <div class="offline-progress-container" v-show="downloadProgress.get('music')?.downloading">
              <div class="offline-progress-bottom" :style="{
                width: `${downloadProgress.get('music')?.percentage || 0}%`,
              }"></div>
              <div class="offline-progress-text">{{ formatFileSize(downloadProgress.get('music')?.downloaded || 0) }}</div>
            </div>
          </ion-item>
          <ion-item :class="[
            'online-item',
            releaseEntity.videoOffline &&
              !downloadProgress.get('video')?.downloading &&
              !preparingDownload.get('video')
              ? 'offline-item'
              : '',
          ]" button @click="handleEntityClick('video')" :disabled="downloadProgress.get('video')?.downloading">
            <ion-label >Видео</ion-label>
            <ion-text slot="end" v-show="downloadProgress.get('video')?.downloading">
              {{ downloadProgress.get("video")?.percentage }}%
            </ion-text>
            <ion-spinner slot="end" v-show="preparingDownload.get('video') && !downloadProgress.get('video')?.downloading" name="crescent"></ion-spinner>
            <ion-icon :icon="cloudDownloadOutline" slot="end" v-show="!releaseEntity.videoOffline &&
              !downloadProgress.get('video')?.downloading &&
              !preparingDownload.get('video')
              "></ion-icon>
            <ion-icon :icon="stopCircle" slot="end" v-show="downloadProgress.get('video')?.downloading"
              @click.stop="stopDownload('video')"></ion-icon>
            <ion-icon :icon="trash" slot="end" v-show="!downloadProgress.get('video')?.downloading &&
              !preparingDownload.get('video') &&
              releaseEntity.videoOffline
              " @click.stop="removeReleaseEntityDirectory('video')"></ion-icon>
            <div class="offline-progress-container" v-show="downloadProgress.get('video')?.downloading">
              <div class="offline-progress-bottom" :style="{
                width: `${downloadProgress.get('video')?.percentage || 0}%`,
              }"></div>
              <div class="offline-progress-text">{{ formatFileSize(downloadProgress.get('video')?.downloaded || 0) }}</div>
            </div>
          </ion-item>
          <ion-item :class="[
            'online-item',
            releaseEntity.guideOffline &&
              !downloadProgress.get('guide')?.downloading &&
              !preparingDownload.get('guide')
              ? 'offline-item'
              : '',
          ]" button @click="handleEntityClick('guide')" :disabled="downloadProgress.get('guide')?.downloading">
            <ion-label >Гайд</ion-label>
            <ion-text slot="end" v-show="downloadProgress.get('guide')?.downloading">
              {{ downloadProgress.get("guide")?.percentage }}%
            </ion-text>
            <ion-spinner slot="end" v-show="preparingDownload.get('guide') && !downloadProgress.get('guide')?.downloading" name="crescent"></ion-spinner>
            <ion-icon :icon="cloudDownloadOutline" slot="end" v-show="!releaseEntity.guideOffline &&
              !downloadProgress.get('guide')?.downloading &&
              !preparingDownload.get('guide')
              "></ion-icon>
            <ion-icon :icon="stopCircle" slot="end" v-show="downloadProgress.get('guide')?.downloading"
              @click.stop="stopDownload('guide')"></ion-icon>
            <ion-icon :icon="trash" slot="end" v-show="!downloadProgress.get('guide')?.downloading &&
              !preparingDownload.get('guide') &&
              releaseEntity.guideOffline
              " @click.stop="removeReleaseEntityDirectory('guide')"></ion-icon>
            <div class="offline-progress-container" v-show="downloadProgress.get('guide')?.downloading">
              <div class="offline-progress-bottom" :style="{
                width: `${downloadProgress.get('guide')?.percentage || 0}%`,
              }"></div>
              <div class="offline-progress-text">{{ formatFileSize(downloadProgress.get('guide')?.downloaded || 0) }}</div>
            </div>
          </ion-item>
        </ion-list>
      </div>

      <div class="release-page-container" style="margin-top: 5em;">
        <div class="release-page-background">
          <img :src="releaseCoverSrc" alt="program page" ref="programImageRef" />
        </div>

        <div class="release-info-container">
          <div class="release-program-name">{{ releaseEntity.programName }}</div>
          <div class="release-number">Релиз {{ releaseEntity.release }}</div>
        </div>

        <div class="media-buttons">
          <ion-button v-on:click="openReleaseDetail('ReleaseMusic')" class="media-button" :disabled="isDownloading ||
            (!releaseEntity.musicOffline && globalContext.offlineMode)
            ">
            <ion-icon :icon="musicalNotesOutline"></ion-icon>
          </ion-button>
          <ion-button v-on:click="openReleaseDetail('ReleaseVideo')" class="media-button media-button-middle" :disabled="isDownloading">
            <ion-icon :icon="filmOutline"></ion-icon>
          </ion-button>
          <ion-button v-on:click="openReleaseDetail('ReleaseGuide')" class="media-button" :disabled="isDownloading ||
            (!releaseEntity.guideOffline && globalContext.offlineMode)
            ">
            <ion-icon :icon="documentOutline"></ion-icon>
          </ion-button>
        </div>
      </div>

      <div :class="['bottom-buttons-container', isLandscapeMode ? 'bottom-buttons-container-landscape' : '']">
        <ion-button @click="showOfflineSelector = true" class="download-button"
          v-show="!isDownloading && !globalContext.offlineMode && isMobile">
          <ion-icon :icon="cloudDownload" v-show="!releaseEntity.musicOffline || !releaseEntity.videoOffline
            "></ion-icon>
          <ion-label v-show="!releaseEntity.musicOffline || !releaseEntity.videoOffline
            " class="ion-margin-start">Загрузить оффлайн</ion-label>

          <ion-icon :icon="cloudDone" v-show="releaseEntity.musicOffline &&
            releaseEntity.videoOffline &&
            releaseEntity.guideOffline
            "></ion-icon>
          <ion-label v-show="releaseEntity.musicOffline && releaseEntity.videoOffline" class="ion-margin-start">Доступно
            оффлайн</ion-label>
        </ion-button>

        <div :class="['admin-buttons', isLandscapeMode ? 'admin-buttons-landscape' : '']">
          <ion-button class="download-button" @click="changeReleaseVisibility(!releaseVisible)"
            v-show="globalContext.isManager && !globalContext.offlineMode">
            <ion-icon :icon="eye" v-show="!releaseVisible"></ion-icon>
            <ion-label v-show="!releaseVisible" class="ion-margin-start">Опубликовать</ion-label>

            <ion-icon :icon="eyeOff" v-show="releaseVisible"></ion-icon>
            <ion-label v-show="releaseVisible" class="ion-margin-start">Скрыть</ion-label>
          </ion-button>
          <ion-button class="download-button" @click="openReleaseSetting()"
            v-show="globalContext.isManager && !globalContext.offlineMode">
            <ion-icon :icon="settings"></ion-icon>
            <ion-label class="ion-margin-start">Настройки</ion-label>
          </ion-button>
        </div>
      </div>

      <ion-modal :can-dismiss="true" @didDismiss="showReleaseSettings = false" :is-open="showReleaseSettings"
        class="release-settings-modal">
        <div class="release-settings-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Настройки</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-item lines="none">
                <ion-label>Кеш аудио</ion-label>
                <ion-icon :icon="reload" slot="end" v-show="!cacheReloadProgress.get('music')?.downloading"
                  @click="reloadAudioCache()"></ion-icon>
                <ion-label v-show="cacheReloadProgress.get('music')?.downloading" slot="end">{{
                  Math.round(
                    ((cacheReloadProgress.get("music")?.currentValue || 0) /
                      (cacheReloadProgress.get("music")?.maxValue || 1)) *
                    100
                  )
                }}%</ion-label>
              </ion-item>
              <ion-item lines="none">
                <ion-label>Кеш видео</ion-label>
                <ion-icon :icon="reload" slot="end" v-show="!cacheReloadProgress.get('video')?.downloading"
                  @click="reloadVideoCache()"></ion-icon>
                <ion-label slot="end" v-show="cacheReloadProgress.get('video')?.downloading">{{
                  Math.round(
                    ((cacheReloadProgress.get("video")?.currentValue || 0) /
                      (cacheReloadProgress.get("video")?.maxValue || 1)) *
                    100
                  )
                }}%</ion-label>
              </ion-item>
            </ion-card-content>
            <div class="release-settings-btn-container">
              <ion-button @click="showReleaseSettings = false" :disabled="cacheReloadProgress.get('video')?.downloading ||
                  cacheReloadProgress.get('music')?.downloading
                  ">
                Закрыть
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <!-- Video Download Mode Dialog -->
      <ion-modal :can-dismiss="true" @didDismiss="showVideoDownloadDialog = false" :is-open="showVideoDownloadDialog"
        class="video-download-modal">
        <div class="release-settings-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выберите режим загрузки</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-item lines="none" button @click="downloadAllVideos()">
                <ion-icon :icon="cloudDownload" slot="start"></ion-icon>
                <ion-label>
                  <h2>Загрузить все видео</h2>
                  <p v-if="getDownloadedVideosCount() === 0">
                    Загрузить все {{ videoList.length }} видео файлов
                  </p>
                  <p v-else-if="getDownloadedVideosCount() < videoList.length">
                    Загрузить все видео (скачано: {{ getDownloadedVideosCount() }}/{{ videoList.length }})
                  </p>
                  <p v-else>
                    Перезагрузить все {{ videoList.length }} видео файлов
                  </p>
                </ion-label>
              </ion-item>
              <ion-item lines="none" button @click="showVideoSelectDialogHandler()">
                <ion-icon :icon="cloudDownloadOutline" slot="start"></ion-icon>
                <ion-label>
                  <h2>Выбрать видео</h2>
                  <p v-if="getDownloadedVideosCount() === 0">
                    Выбрать отдельные видео для загрузки
                  </p>
                  <p v-else>
                    Выбрать видео (скачано: {{ getDownloadedVideosCount() }}/{{ videoList.length }})
                  </p>
                </ion-label>
              </ion-item>
            </ion-card-content>
            <div class="release-settings-btn-container">
              <ion-button @click="showVideoDownloadDialog = false">
                Отмена
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <!-- Video Selection Dialog -->
      <ion-modal :can-dismiss="true" @didDismiss="showVideoSelectDialog = false" :is-open="showVideoSelectDialog"
        class="video-select-modal">
        <div class="release-settings-card-container bg-transparent">
          <ion-card>
            <ion-card-header mode="ios">
              <ion-card-title>Выберите видео</ion-card-title>
            </ion-card-header>
            <ion-card-content class="video-select-content">
              <ion-list>
                <ion-item 
                  v-for="video in videoList" 
                  :key="video.id"
                  :class="['video-select-item', isVideoOffline(video.id) ? 'offline-item' : '', isVideoDownloading(video.id) ? 'downloading-item' : '']"
                >
                  <ion-label>
                    <h2>{{ formatVideoName(video.name) }}</h2>
                    <p>{{ getVideoStatus(video.id) }}</p>
                    <p v-if="!isVideoOffline(video.id) && !isVideoDownloading(video.id)" class="video-status-hint">
                      Не скачано
                    </p>
                  </ion-label>
                  <div class="single-video-progress-container" v-show="isVideoDownloading(video.id)">
                    <div class="single-video-progress-bar" :style="{
                      width: `${singleVideoProgress.get(video.id)?.percentage || 0}%`,
                    }"></div>
                  </div>
                  <div slot="end" class="video-select-actions">
                    <ion-icon 
                      :icon="cloudDone" 
                      v-show="isVideoOffline(video.id) && !isVideoDownloading(video.id)"
                      class="video-select-icon"
                    ></ion-icon>
                    <ion-icon 
                      :icon="cloudDownloadOutline" 
                      v-show="!isVideoOffline(video.id) && !isVideoDownloading(video.id)"
                      class="video-select-icon"
                      @click="downloadSingleVideo(video)"
                    ></ion-icon>
                    <ion-icon 
                      :icon="stopCircle" 
                      v-show="isVideoDownloading(video.id)"
                      class="video-select-icon"
                      @click="stopVideoDownload(video)"
                    ></ion-icon>
                    <ion-icon 
                      :icon="trash" 
                      v-show="isVideoOffline(video.id) && !isVideoDownloading(video.id)"
                      class="video-select-icon"
                      @click="removeSingleVideo(video)"
                    ></ion-icon>
                  </div>
                </ion-item>
              </ion-list>
            </ion-card-content>
            <div class="release-settings-btn-container">
              <ion-button 
                @click="downloadRemainingVideos()" 
                v-show="hasRemainingVideos() && !downloadProgress.get('video')?.downloading"
                fill="outline"
                class="download-remaining-button"
              >
                <ion-icon :icon="cloudDownload" slot="start"></ion-icon>
                Загрузить оставшиеся ({{ getRemainingVideosCount() }})
              </ion-button>
              <ion-button @click="showVideoSelectDialog = false">
                Закрыть
              </ion-button>
            </div>
          </ion-card>
        </div>
      </ion-modal>

      <ion-toast cssClass="custom-toast" :is-open="isDownloading"
        message="Не закрывайте приложение и окно до завершения процесса" position="top" color="dark">
      </ion-toast>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from "@/model/globalcontext.model";
import { GoogleMedia } from "@/model/googlemedia.model";
import { MediaProgressBar } from "@/model/mediaprogressbar.model";
import { PlayerModes } from "@/model/player.mode";
import { PlayerBar } from "@/model/playerbar.model";
import { Playlist } from "@/model/playlist.model";
import { Release } from "@/model/release.model";
import FilesystemCustomUtils from "@/services/filesystem.custom.utils";
import { bundledProgramImageUrl } from "@/services/logo.service";
import UnicodeUtils from "@/services/unicode.utils";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation";
import { Capacitor, CapacitorHttp, HttpOptions } from "@capacitor/core";
import { Directory, Encoding, Filesystem } from "@capacitor/filesystem";
import { Preferences } from "@capacitor/preferences";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonPage,
  IonSpinner,
  IonText,
  IonToast,
} from "@ionic/vue";
import axios from "axios";
import {
  arrowBackOutline,
  close,
  cloudDone,
  cloudDownload,
  cloudDownloadOutline,
  cloudOutline,
  documentOutline,
  eye,
  eyeOff,
  filmOutline,
  homeOutline,
  musicalNotesOutline,
  reload,
  settings,
  stopCircle,
  trash,
} from "ionicons/icons";
import { defineComponent, inject, ref } from "vue";
// @ts-ignore
import { MittEmitter } from "mitt-emitter";

export default defineComponent({
  name: "ReleasePage",
  components: {
    IonContent,
    IonPage,
    IonButton,
    IonIcon,
    IonList,
    IonListHeader,
    IonItem,
    IonLabel,
    IonText,
    IonToast,
    IonModal,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonSpinner,
  },

  setup() {
    const playerBar = inject("playerBar") as PlayerBar;
    const releaseEntity = inject("release") as Release;
    const programImageRef = ref();
    const globalContext = inject("globalContext") as GlobalContext;
    const isMobile = globalContext.isMobile;
    const filesystemCustomUtils = new FilesystemCustomUtils();
    const unicodeUtils = new UnicodeUtils();
    const emitter = inject("emitter") as MittEmitter;

    const mimeExtensions: Map<string, string> = new Map([
      ["image/jpeg", "jpg"],
      ["image/png", "png"],
      ["application/json", "json"],
      ["audio/mpeg", "mp3"],
      ["video/mp4", "mp4"],
      ["video/mpeg", "mpeg"],
      ["video/quicktime", "mov"],
      ["application/pdf", "pdf"],
    ]);

    return {
      musicalNotesOutline,
      filmOutline,
      documentOutline,
      arrowBackOutline,
      cloudDownload,
      cloudDownloadOutline,
      cloudDone,
      cloudOutline,
      stopCircle,
      trash,
      close,
      playerBar,
      releaseEntity,
      programImageRef,
      mimeExtensions,
      eye,
      eyeOff,
      globalContext,
      isMobile,
      filesystemCustomUtils,
      unicodeUtils,
      emitter,
      settings,
      reload,
      homeOutline,
    };
  },

  data() {
    return {
      storedReleaseImagePath: "",
      musicList: Array<GoogleMedia>(),
      videoList: Array<GoogleMedia>(),
      showOfflineSelector: false,
      programName: "",
      programShortName: "",
      releaseId: 0,
      release: "",
      releaseVisible: false,
      releaseWithZero: "",
      musicDirectory: "",
      videoDirectory: "",
      guideDirectory: "",
      imageDirectory: "",
      showReleaseSettings: false,
      prevRouteName: "",
      isLandscapeMode: false,

      cacheReloadProgress: new Map<string, MediaProgressBar>([
        ["music", new MediaProgressBar()],
        ["video", new MediaProgressBar()],
        ["guide", new MediaProgressBar()],
      ]),

      downloadProgress: new Map<string, MediaProgressBar>([
        ["music", new MediaProgressBar()],
        ["video", new MediaProgressBar()],
        ["guide", new MediaProgressBar()],
      ]),

      // Video download dialogs
      showVideoDownloadDialog: false,
      showVideoSelectDialog: false,
      currentEntityType: '',
      downloadingVideos: new Map<string, boolean>(),
      offlineVideos: new Map<string, boolean>(),
      // Track progress for individual video downloads
      singleVideoProgress: new Map<string, MediaProgressBar>(),
      
      // Track active download utils instances for cancellation
      activeDownloadUtils: new Map<string, FilesystemCustomUtils>(),
      
      // Track preparing state for download indication
      preparingDownload: new Map<string, boolean>([
        ["music", false],
        ["video", false],
        ["guide", false],
      ]),
    };
  },

  computed: {
    isDownloading(): boolean {
      let isDownloading = false;
      this.downloadProgress.forEach((progress) => {
        if (progress.downloading) isDownloading = true;
      });

      return isDownloading;
    },
    releaseCoverSrc(): string {
      const stored = this.storedReleaseImagePath?.trim();
      if (stored) {
        return this.storedReleaseImagePath;
      }
      return bundledProgramImageUrl(this.programShortName);
    },
  },

  mounted() {
    try {
      if (this.isMobile) {
        this.isLandscapeMode =
          ScreenOrientation.type ==
          ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
          ScreenOrientation.type ==
          ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
          ScreenOrientation.type ==
          ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        ScreenOrientation.onChange().subscribe(() => {
          this.isLandscapeMode =
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY ||
            ScreenOrientation.type ==
            ScreenOrientation.ORIENTATIONS.LANDSCAPE_SECONDARY;
        });
      }
    } catch (ex) {
      //not supported
    }
  },

  ionViewWillEnter() {
    // Stop loading immediately so buttons are visible right away
    if (this.globalContext.isLoading) {
      this.globalContext.isLoading = false;
    }

    Preferences.get({ key: "releaseMeta" }).then((releaseMeta) => {
      if (releaseMeta.value) {
        const releaseMetaData = JSON.parse(releaseMeta.value);
        this.prevRouteName = String(releaseMetaData.prevRouteName || '');
        this.programName = String(releaseMetaData.programName);
        this.programShortName = String(releaseMetaData.programShortName);
        this.releaseId = Number(releaseMetaData.releaseId);
        this.release = String(releaseMetaData.release);
        this.releaseVisible = releaseMetaData.releaseVisible === "true";
        this.releaseWithZero =
          this.release && this.release.length === 1
            ? "0" + this.release
            : this.release;
        this.musicDirectory = `${this.programShortName + "_" + this.releaseWithZero + "_Music"
          }`;
        this.videoDirectory = `${this.programShortName + "_" + this.releaseWithZero + "_Video"
          }`;
        this.guideDirectory = `${this.programShortName + "_" + this.releaseWithZero + "_Guide"
          }`;
        this.imageDirectory = `${this.programShortName + "_" + this.releaseWithZero + "_Image"
          }`;

        this.releaseEntity.clearFields();
        this.releaseEntity.programName = this.programName;
        this.releaseEntity.programShortName = this.programShortName;
        this.releaseEntity.id = this.releaseId;
        this.releaseEntity.release = this.release;
        this.releaseEntity.visible = this.releaseVisible;
        this.releaseEntity.releaseWithZero = this.releaseWithZero;
        this.releaseEntity.musicDirectory = this.musicDirectory;
        this.releaseEntity.videoDirectory = this.videoDirectory;
        this.releaseEntity.guideDirectory = this.guideDirectory;
        this.releaseEntity.imageDirectory = this.imageDirectory;
        this.releaseEntity.contentSource = releaseMetaData.contentSource || 'GOOGLE';

        this.storedReleaseImagePath = '';

        console.log('=== ReleasePage: Release metadata ===');
        console.log('Release ID:', this.releaseId);
        console.log('Content Source from metadata:', releaseMetaData.contentSource);
        console.log('Content Source set to:', this.releaseEntity.contentSource);
        console.log('=====================================');

        const releaseImagePath = `${this.programShortName}_${this.release && this.release.length === 1
          ? "0" + this.release
          : this.release
          }.png`;

        // Load image asynchronously without blocking UI
        this.loadReleaseImage(releaseImagePath);

        // Check offline status - even if flag is false, verify by file count
        this.isOffline();
        
        // Also check by file count to catch cases where files are downloaded but flag wasn't set
        if (!this.releaseEntity.videoOffline) {
          setTimeout(async () => {
            const isOffline = await this.checkOfflineByFileCount('video');
            if (isOffline) {
              this.releaseEntity.videoOffline = true;
            }
          }, 500);
        }
        
        if (!this.releaseEntity.musicOffline) {
          setTimeout(async () => {
            const isOffline = await this.checkOfflineByFileCount('music');
            if (isOffline) {
              this.releaseEntity.musicOffline = true;
            }
          }, 500);
        }
        
        // Check individual video offline status
        if (this.videoList.length > 0) {
          this.checkVideoOfflineStatus();
        } else {
          // Fetch video list to check status
          this.fetchVideoList().then(() => {
            this.checkVideoOfflineStatus();
          });
        }
      }
    });

    if (
      this.playerBar.currentMode === PlayerModes.MICRO ||
      this.playerBar.microMode
    ) {
      this.playerBar.currentMode = PlayerModes.EXTENDED;
      this.playerBar.microMode = false;
      this.playerBar.visible = true;
    }
  },

  ionViewWillLeave() {
    // Don't clear storedReleaseImagePath here - it's loaded from persistent cache
    // Clearing it would require re-checking filesystem on next visit
    // Only clear if needed for memory management, but image is already cached on disk
  },

  methods: {
    handleEntityClick(entityType: string) {
      // Handle click on entire row
      const isDownloading = this.downloadProgress.get(entityType)?.downloading;
      const isPreparing = this.preparingDownload.get(entityType);
      
      if (isDownloading || isPreparing) {
        return; // Don't do anything if already downloading or preparing
      }
      
      // For video, always show dialog (even if partially or fully downloaded)
      // This allows downloading remaining files or re-downloading
      if (entityType === 'video') {
        this.downloadRelease(entityType);
        return;
      }
      
      if (this.releaseEntity[`${entityType}Offline` as keyof Release]) {
        // If offline, do nothing (or could show info)
        return;
      }
      
      // Start download for music and guide
      this.downloadRelease(entityType);
    },

    async loadReleaseImage(releaseImagePath: string) {
      // Don't block UI - buttons are already visible
      if (this.isMobile) {
        // First, always try to load from persistent cache (Directory.Data)
        try {
          // Ensure directory exists
          await Filesystem.mkdir({
            path: this.imageDirectory,
            directory: Directory.Data,
            recursive: true
          }).catch(() => {
            // Directory already exists, ignore
          });

          // Check if image file exists in persistent storage
          const fullImagePath = `${this.imageDirectory}/${releaseImagePath}`;
          
          try {
            const fileStats = await Filesystem.stat({
              path: fullImagePath,
              directory: Directory.Data,
            });
            
            // If file exists and has size > 0, load it from cache
            if (fileStats && fileStats.size > 0) {
              const storedImage = await Filesystem.getUri({
                path: fullImagePath,
                directory: Directory.Data,
              });
              this.storedReleaseImagePath = Capacitor.convertFileSrc(storedImage.uri);
              this.releaseEntity.imageDirectory = this.imageDirectory;
              this.releaseEntity.imagePath = releaseImagePath;
              this.globalContext.isLoading = false;
              console.log(`Loaded release image from cache: ${fullImagePath}`);
              return;
            }
          } catch (statError) {
            // File doesn't exist, will download
            console.log('Image not found in persistent cache, will download');
          }
        } catch (error) {
          // Cache directory doesn't exist or error accessing it - will download
          console.log('Cache directory error, will download image:', error);
        }

        // If not in cache and not in offline mode, download and save to persistent cache
        if (!this.globalContext.offlineMode) {
          try {
            // Create directory if needed
            await Filesystem.mkdir({
              path: this.imageDirectory,
              directory: Directory.Data,
              recursive: true
            }).catch(() => {
              // Directory already exists, ignore
            });

            const tokenQuery = await Preferences.get({ key: "jwt" });
            let token = tokenQuery.value?.trim() || '';
            if (!token && Capacitor.isNativePlatform()) {
              token = localStorage.getItem('jhi-authenticationToken')?.trim() || '';
            }

            let response;
            
            // Check if release uses server storage
            console.log('=== LoadReleaseImage (Mobile) ===');
            console.log('contentSource:', this.releaseEntity.contentSource);
            console.log('releaseId:', this.releaseId);
            
            const coverHttpOpts = (url: string): HttpOptions => {
              const o: HttpOptions = { url, readTimeout: 120000 };
              if (token) {
                o.headers = { Authorization: `Bearer ${token}` };
              }
              return o;
            };

            if (this.releaseEntity.contentSource === 'SERVER') {
              // Download cover from server
              console.log('Loading cover from SERVER:', `/api/releases/${this.releaseId}/cover/base64`);
              response = await CapacitorHttp.get(
                coverHttpOpts(`${process.env.VUE_APP_API_URL}api/releases/${this.releaseId}/cover/base64`)
              );
            } else {
              // Download from Google Drive (original logic)
              console.log('Loading cover from GOOGLE:', releaseImagePath);
              response = await CapacitorHttp.get(
                coverHttpOpts(`${process.env.VUE_APP_API_EXT_URL}api/google/file/base64/name/${releaseImagePath}`)
              );
            }

            if (
              response.status < 200 ||
              response.status >= 300 ||
              response.data == null ||
              (typeof response.data === 'string' && response.data.trim() === '')
            ) {
              this.storedReleaseImagePath = '';
              return;
            }

            // Always save to filesystem for persistent caching (Directory.Data persists between app sessions)
            const fullImagePath = `${this.imageDirectory}/${releaseImagePath}`;
            
            try {
              // Save image to persistent storage
              await Filesystem.writeFile({
                path: fullImagePath,
                data: response.data,
                directory: Directory.Data,
                recursive: true
              });
              
              // Verify the file was saved successfully
              const savedFile = await Filesystem.getUri({
                path: fullImagePath,
                directory: Directory.Data,
              });
              
              if (savedFile && savedFile.uri) {
                // Load from saved file URI for optimal performance
                this.storedReleaseImagePath = Capacitor.convertFileSrc(savedFile.uri);
                this.releaseEntity.imageDirectory = this.imageDirectory;
                this.releaseEntity.imagePath = releaseImagePath;
                console.log(`Saved release image to persistent cache: ${fullImagePath}`);
              } else {
                // Fallback to base64 if URI not available
                this.storedReleaseImagePath = `data:image/jpg;base64,${response.data}`;
              }
            } catch (writeError) {
              console.error('Failed to save image to persistent cache:', writeError);
              // If filesystem write fails, use base64 directly as fallback
              this.storedReleaseImagePath = `data:image/jpg;base64,${response.data}`;
            }
          } catch (error) {
            console.error('Failed to load release image:', error);
            this.storedReleaseImagePath = '';
          } finally {
            this.globalContext.isLoading = false;
          }
        } else {
          this.globalContext.isLoading = false;
        }
      } else {
        // Web platform
        if (!this.globalContext.offlineMode) {
          try {
            let response;
            
            // Check if release uses server storage
            console.log('=== LoadReleaseImage (Web) ===');
            console.log('contentSource:', this.releaseEntity.contentSource);
            console.log('releaseId:', this.releaseId);
            
            if (this.releaseEntity.contentSource === 'SERVER') {
              // Download cover from server
              console.log('Loading cover from SERVER:', `/api/releases/${this.releaseId}/cover/base64`);
              response = await axios.get(
                `${process.env.VUE_APP_API_URL}api/releases/${this.releaseId}/cover/base64`
              );
            } else {
              // Download from Google Drive (original logic)
              console.log('Loading cover from GOOGLE:', releaseImagePath);
              response = await axios.get(
                `${process.env.VUE_APP_API_EXT_URL}api/google/file/base64/name/${releaseImagePath}`
              );
            }

            const body = response.data;
            if (body == null || (typeof body === 'string' && body.trim() === '')) {
              this.storedReleaseImagePath = '';
              return;
            }

            this.storedReleaseImagePath = `data:image/jpg;base64,${body}`;
            this.releaseEntity.imagePath = releaseImagePath;
          } catch (error) {
            console.error('Failed to load release image:', error);
            this.storedReleaseImagePath = '';
          } finally {
            this.globalContext.isLoading = false;
          }
        } else {
          this.globalContext.isLoading = false;
        }
      }
    },

    returnBack(componentName?: string) {
      if (componentName === 'Program') {
        Preferences.set({
          key: "programMeta",
          value: JSON.stringify({
            programName: this.programName,
            programShortName: this.programShortName,
          }),
        })
      }
      this.$router.replace({
        name: componentName && componentName !== '' ? componentName : "Programs",
      });
    },
    openReleaseDetail(releaseDetail: string) {
      this.isOffline();

      this.$router.push({
        name: releaseDetail,
      });
    },

    hideOfflineSelector() {
      this.showOfflineSelector = false;
    },

    clearProgressBar(entityType: string) {
      const entityProgressBar = this.downloadProgress.get(entityType);
      if (entityProgressBar) {
        entityProgressBar.currentValue = 0;
        entityProgressBar.maxValue = 0;
        entityProgressBar.downloaded = 0;
        entityProgressBar.downloading = false;
      }
    },

    async stopDownload(entityType: string) {
      console.log(`Stopping download for ${entityType}`);
      
      // Get the active download utils instance if it exists
      let filesystemCustomUtils = this.activeDownloadUtils.get(entityType);
      
      // If no active instance, create one for cleanup
      if (!filesystemCustomUtils) {
        console.log(`No active download instance for ${entityType}, creating new one for cleanup`);
        filesystemCustomUtils = new FilesystemCustomUtils();
        filesystemCustomUtils.setRelease(
          this.releaseEntity.programName,
          this.releaseEntity.programShortName,
          this.releaseEntity.releaseWithZero,
          this.releaseEntity.id,
          this.releaseEntity.contentSource
        );
      } else {
        // Cancel all downloads using the same instance
        filesystemCustomUtils.cancelAllDownloads();
      }
      
      // Clean up partial files
      const tempPlaylist = new Playlist('', '', '');
      if (entityType === 'music') {
        tempPlaylist.id = this.musicDirectory;
      } else if (entityType === 'video') {
        tempPlaylist.id = this.videoDirectory;
      } else if (entityType === 'guide') {
        tempPlaylist.id = this.guideDirectory;
      }
      
      if (tempPlaylist.id) {
        console.log(`Cleaning up partial downloads for ${tempPlaylist.id}`);
        await filesystemCustomUtils.cleanupPartialDownloads(tempPlaylist);
      }
      
      // Remove from active downloads
      this.activeDownloadUtils.delete(entityType);
      
      this.clearProgressBar(entityType);
      this.isOffline(entityType);
    },

    breakAllActiveDownloads() {
      //stop music
      const musicProgressbar = this.downloadProgress.get("music");
      if (undefined !== musicProgressbar && musicProgressbar.downloading) {
        this.stopDownload("music");
        setTimeout(() => {
          this.removeReleaseEntityDirectory("music");
        }, 5000);
      }
      //stop video
      const videoProgressbar = this.downloadProgress.get("video");
      if (undefined !== videoProgressbar && videoProgressbar.downloading) {
        this.stopDownload("video");
        setTimeout(() => {
          this.removeReleaseEntityDirectory("video");
        }, 5000);
      }
      //stop guide
      const guideProgressbar = this.downloadProgress.get("guide");
      if (undefined !== guideProgressbar && guideProgressbar.downloading) {
        this.stopDownload("guide");
        setTimeout(() => {
          this.removeReleaseEntityDirectory("guide");
        }, 5000);
      }
    },

    createUuid(): string {
      let dt = new Date().getTime();
      const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },

    async downloadRelease(entityType: string) {
      // Set preparing state
      this.preparingDownload.set(entityType, true);
      
      try {
        // For video, always show dialog to choose download mode (even if all downloaded)
        if (entityType === 'video') {
          this.currentEntityType = entityType;
          await this.fetchVideoList();
          // Always show dialog, even if files are already downloaded
          // This allows re-downloading or downloading remaining files
          await this.checkVideoOfflineStatus();
          this.showVideoDownloadDialog = true;
          this.preparingDownload.set(entityType, false);
          return;
        }

        // For music and guide, proceed with normal download
        this.removeReleaseEntityDirectory(entityType).then((result: boolean) => {
        if (result) {
          const filesystemCustomUtils = new FilesystemCustomUtils();
          this.activeDownloadUtils.set(entityType, filesystemCustomUtils); // Track instance for cancellation
          
          const entityProgressBar = this.downloadProgress.get(entityType);
          if (typeof entityProgressBar !== "undefined") {
            entityProgressBar.downloading = true;
            entityProgressBar.id = this.createUuid();
            entityProgressBar.startDownload(); // Initialize timing
            filesystemCustomUtils.setProgressBar(entityProgressBar); // Set progress bar

            this.emitter.on(`downloaded-${entityProgressBar.id}`, async () => {
              if ("music" == entityType) {
                // Используем тот же путь верификации, что и при открытии релиза (isPlaylistOffline),
                // — он корректно обрабатывает вложенные id вида `releases/.../track.mp3`,
                // тогда как checkOfflineByFileCount опирается на плоский readdir.
                this.isOffline('music');
              } else if ("video" == entityType) {
                // For video, check by file count
                const isOffline = await this.checkOfflineByFileCount('video');
                if (isOffline) {
                  this.releaseEntity.videoOffline = true;
                }
              } else if ("guide" == entityType) {
                // For guide, check if pages are downloaded
                // Wait a bit to ensure all files are written
                await new Promise(resolve => setTimeout(resolve, 500));
                
                try {
                  const dirContent = await Filesystem.readdir({
                    path: this.guideDirectory,
                    directory: Directory.Data,
                  });
                  // Guide is offline if there are PNG files (pages) with size > 0
                  const hasPages = dirContent.files.some(f => f.name.endsWith('png') && f.size > 0);
                  if (hasPages) {
                    this.releaseEntity.guideOffline = true;
                    console.log(`Guide offline status set to true - found ${dirContent.files.filter(f => f.name.endsWith('png') && f.size > 0).length} pages`);
                  } else {
                    console.warn('Guide pages not found after download completion');
                    // Try one more time after delay
                    setTimeout(async () => {
                      try {
                        const retryContent = await Filesystem.readdir({
                          path: this.guideDirectory,
                          directory: Directory.Data,
                        });
                        const retryHasPages = retryContent.files.some(f => f.name.endsWith('png') && f.size > 0);
                        if (retryHasPages) {
                          this.releaseEntity.guideOffline = true;
                        }
                      } catch (retryError) {
                        console.error('Error retrying guide check:', retryError);
                      }
                    }, 1000);
                  }
                } catch (error) {
                  console.error('Error checking guide offline status:', error);
                  // Try again after delay
                  setTimeout(async () => {
                    try {
                      const retryContent = await Filesystem.readdir({
                        path: this.guideDirectory,
                        directory: Directory.Data,
                      });
                      const retryHasPages = retryContent.files.some(f => f.name.endsWith('png') && f.size > 0);
                      if (retryHasPages) {
                        this.releaseEntity.guideOffline = true;
                      }
                    } catch (retryError) {
                      console.error('Error retrying guide check:', retryError);
                    }
                  }, 1000);
                }
              }
              
              // Remove from active downloads when complete
              this.activeDownloadUtils.delete(entityType);
            });
          }
          filesystemCustomUtils.setRelease(
            this.releaseEntity.programName,
            this.releaseEntity.programShortName,
            this.releaseEntity.releaseWithZero,
            this.releaseEntity.id,
            this.releaseEntity.contentSource
          );
          filesystemCustomUtils.setEmitter(this.emitter);

          filesystemCustomUtils.downloadRelease(entityType);
          
          // Clear preparing state when download actually starts
          const progressBar = this.downloadProgress.get(entityType);
          if (progressBar?.downloading) {
            this.preparingDownload.set(entityType, false);
          }
        }
      }).finally(() => {
        // Clear preparing state if something went wrong
        setTimeout(() => {
          const entityProgressBar = this.downloadProgress.get(entityType);
          if (!entityProgressBar?.downloading) {
            this.preparingDownload.set(entityType, false);
          }
          }, 1000);
      });
      } catch (error) {
        console.error(`Error preparing download for ${entityType}:`, error);
        this.preparingDownload.set(entityType, false);
      }
    },

    /** Relative path of a downloaded video file under `videoDirectory` (Google id + ext, or server path `releases/...`). */
    releaseVideoStoredRelativePath(video: GoogleMedia): string {
      const id = video.id || '';
      const fileExtension = this.mimeExtensions.get(video.mimeType || '') || 'mp4';
      if (id.includes('/')) {
        return id;
      }
      return `${id}.${fileExtension}`;
    },

    async fetchVideoList() {
      try {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        let token = tokenQuery.value?.trim() || '';
        if (!token && Capacitor.isNativePlatform()) {
          token = localStorage.getItem('jhi-authenticationToken')?.trim() || '';
        }

        const url =
          this.releaseEntity.contentSource === 'SERVER' && this.releaseId
            ? `${process.env.VUE_APP_API_URL}api/releases/${this.releaseId}/media/video`
            : `${process.env.VUE_APP_API_URL}api/google/media/${this.releaseEntity.videoDirectory}`;

        const options: HttpOptions = {
          url,
          readTimeout: 60000,
        };
        if (token) {
          options.headers = { Authorization: `Bearer ${token}` };
        }

        const response = await CapacitorHttp.get(options);
        let data = response.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch {
            data = [];
          }
        }
        this.videoList = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Failed to fetch video list', error);
        this.videoList = [];
      }
    },

    async downloadSingleVideo(video: GoogleMedia) {
      if (!video) return;

      this.downloadingVideos.set(video.id, true);

      // Create progress bar for single video download
      const videoProgressBar = new MediaProgressBar();
      videoProgressBar.id = `single-video-${video.id}`;
      videoProgressBar.downloading = true;
      videoProgressBar.maxValue = 1;
      videoProgressBar.currentValue = 0;
      videoProgressBar.startDownload();
      this.singleVideoProgress.set(video.id, videoProgressBar);

      try {
        const filesystemCustomUtils = new FilesystemCustomUtils();
        filesystemCustomUtils.setRelease(
          this.releaseEntity.programName,
          this.releaseEntity.programShortName,
          this.releaseEntity.releaseWithZero,
          this.releaseEntity.id,
          this.releaseEntity.contentSource
        );

        // Set progress bar for tracking
        filesystemCustomUtils.setProgressBar(videoProgressBar);

        // Download single video file with progress tracking
        await filesystemCustomUtils.downloadFileChunked(
          video.id,
          this.releaseEntity.videoDirectory,
          video.mimeType
        );

        this.offlineVideos.set(video.id, true);
        
        // Check if all videos are now offline by counting files
        await this.checkVideoOfflineStatus();
        const downloadedCount = Array.from(this.offlineVideos.values()).filter(v => v).length;
        const allVideosCount = this.videoList.length;
        
        // Only mark as offline if ALL videos are downloaded
        if (downloadedCount === allVideosCount && allVideosCount > 0) {
          // Create or update playlist with downloaded videos
          // This allows the offline status to be properly detected
          await filesystemCustomUtils.createOrUpdateVideoPlaylist(
            this.releaseEntity.videoDirectory,
            this.videoList,
            this.releaseEntity.programName,
            this.releaseEntity.programShortName,
            this.releaseEntity.releaseWithZero
          );
          // Set offline flag only when all videos are downloaded
          this.releaseEntity.videoOffline = true;
        } else {
          // Update playlist but don't mark as fully offline yet
          await filesystemCustomUtils.createOrUpdateVideoPlaylist(
            this.releaseEntity.videoDirectory,
            this.videoList,
            this.releaseEntity.programName,
            this.releaseEntity.programShortName,
            this.releaseEntity.releaseWithZero
          );
          // Don't set videoOffline to true if not all videos are downloaded
          // This allows access to video selection dialog
        }
        
        // Don't refresh offline status here if not all videos downloaded
        // This prevents overwriting the flag and blocking dialog access
        // Only refresh if all videos are downloaded
        if (downloadedCount === allVideosCount && allVideosCount > 0) {
          this.isOffline('video');
        } else {
          // Just update individual video status without checking full offline status
          // This allows dialog to remain accessible
          await this.checkVideoOfflineStatus();
        }
      } catch (error) {
        console.error('Failed to download video', error);
      } finally {
        this.downloadingVideos.delete(video.id);
        // Clean up progress bar
        const progressBar = this.singleVideoProgress.get(video.id);
        if (progressBar) {
          progressBar.downloading = false;
          this.singleVideoProgress.delete(video.id);
        }
      }
    },

    async downloadAllVideos() {
      this.showVideoDownloadDialog = false;
      
      this.removeReleaseEntityDirectory(this.currentEntityType).then((result) => {
        if (result) {
          const filesystemCustomUtils = new FilesystemCustomUtils();
          this.activeDownloadUtils.set(this.currentEntityType, filesystemCustomUtils); // Track instance
          
          const entityProgressBar = this.downloadProgress.get(this.currentEntityType);
          if (typeof entityProgressBar !== "undefined") {
            entityProgressBar.downloading = true;
            entityProgressBar.id = this.createUuid();
            entityProgressBar.startDownload(); // Initialize timing
            filesystemCustomUtils.setProgressBar(entityProgressBar); // Set progress bar BEFORE download

            this.emitter.on(`downloaded-${entityProgressBar.id}`, async () => {
              // Wait a bit to ensure playlist is fully written to disk
              await new Promise(resolve => setTimeout(resolve, 1000));
              
              // Check offline status by counting files - more reliable than just checking playlist
              const isOffline = await this.checkOfflineByFileCount('video');
              
              if (isOffline) {
                // All files downloaded - set offline flag
                this.releaseEntity.videoOffline = true;
                await this.checkVideoOfflineStatus();
                this.isOffline('video');
              } else {
                // Not all files downloaded - check playlist anyway
                try {
                  const dirContent = await Filesystem.readdir({
                    path: this.videoDirectory,
                    directory: Directory.Data,
                  });
                  
                  const playlistExists = dirContent.files.some(f => 
                    f.name === this.filesystemCustomUtils.PLAYLIST_PATH && f.size > 0
                  );
                  
                  if (playlistExists) {
                    // Verify by checking playlist
                    await this.checkVideoOfflineStatus();
                    this.isOffline('video');
                  }
                } catch (error) {
                  console.error('Error verifying video after download:', error);
                }
              }
              
              this.activeDownloadUtils.delete(this.currentEntityType); // Remove when complete
            });
          }
          filesystemCustomUtils.setRelease(
            this.releaseEntity.programName,
            this.releaseEntity.programShortName,
            this.releaseEntity.releaseWithZero,
            this.releaseEntity.id,
            this.releaseEntity.contentSource
          );
          filesystemCustomUtils.setEmitter(this.emitter);

          filesystemCustomUtils.downloadRelease(this.currentEntityType);
        }
      });
    },

    hasRemainingVideos(): boolean {
      return this.videoList.some(video => !this.isVideoOffline(video.id));
    },

    getRemainingVideosCount(): number {
      return this.videoList.filter(video => !this.isVideoOffline(video.id)).length;
    },

    getDownloadedVideosCount(): number {
      return this.videoList.filter(video => this.isVideoOffline(video.id)).length;
    },

    async downloadRemainingVideos() {
      const remainingVideos = this.videoList.filter(video => !this.isVideoOffline(video.id));
      
      if (remainingVideos.length === 0) {
        return;
      }

      // Close the dialog
      this.showVideoSelectDialog = false;

      // Download remaining videos one by one
      for (const video of remainingVideos) {
        if (this.downloadingVideos.has(video.id)) {
          continue; // Skip if already downloading
        }
        
        await this.downloadSingleVideo(video);
      }

      // After all remaining videos are downloaded, update playlist and check offline status
      await this.checkVideoOfflineStatus();
      this.isOffline('video');
    },

    formatTimeRemaining(progressBar?: MediaProgressBar): string {
      if (!progressBar || !progressBar.downloading) {
        return '--:--';
      }
      return progressBar.getFormattedTimeRemaining();
    },

    async showVideoSelectDialogHandler() {
      this.showVideoDownloadDialog = false;
      
      // Check which videos are already offline
      await this.checkVideoOfflineStatus();
      
      this.showVideoSelectDialog = true;
    },

    async checkVideoOfflineStatus() {
      try {
        this.offlineVideos.clear();

        for (const video of this.videoList) {
          const rel = this.releaseVideoStoredRelativePath(video);
          try {
            const st = await Filesystem.stat({
              path: `${this.videoDirectory}/${rel}`,
              directory: Directory.Data,
            });
            if (st && st.size > 0) {
              this.offlineVideos.set(video.id, true);
            }
          } catch {
            /* not downloaded */
          }
        }
      } catch (error) {
        console.log('Video directory not found or empty', error);
        this.offlineVideos.clear();
      }
    },

    isVideoOffline(videoId: string): boolean {
      return this.offlineVideos.has(videoId);
    },

    isVideoDownloading(videoId: string): boolean {
      return this.downloadingVideos.has(videoId);
    },

    getVideoStatus(videoId: string): string {
      if (this.isVideoOffline(videoId)) {
        return 'Оффлайн';
      } else if (this.isVideoDownloading(videoId)) {
        const progressBar = this.singleVideoProgress.get(videoId);
        if (progressBar && progressBar.downloading) {
          const size = this.formatFileSize(progressBar.downloaded || 0);
          const percentage = progressBar.percentage || 0;
          return `${percentage}% • ${size}`;
        }
        return 'Загрузка...';
      }
      return '';
    },

    formatVideoName(name: string): string {
      if (!name) return '';
      const pattern = /(\d{2})_(.*?)\.mp4/;
      const match = name.match(pattern);
      if (match) {
        const prefix = parseInt(match[1], 10);
        let formattedName = match[2];
        if (prefix > 0) {
          formattedName = `${prefix} - ${formattedName}`;
        }
        return formattedName;
      }
      return name;
    },

    formatFileSize(sizeMB: number): string {
      if (sizeMB < 0.001) {
        return '0 кБ';
      } else if (sizeMB < 1) {
        return `${(sizeMB * 1024).toFixed(1)} кБ`;
      } else if (sizeMB < 1024) {
        return `${sizeMB.toFixed(1)} МБ`;
      } else {
        return `${(sizeMB / 1024).toFixed(2)} ГБ`;
      }
    },

    async stopVideoDownload(video: GoogleMedia) {
      if (!video) return;

      this.downloadingVideos.delete(video.id);

      // Clean up progress bar
      const progressBar = this.singleVideoProgress.get(video.id);
      if (progressBar) {
        progressBar.downloading = false;
        this.singleVideoProgress.delete(video.id);
      }

      const filesystemCustomUtils = new FilesystemCustomUtils();
      filesystemCustomUtils.setRelease(
        this.releaseEntity.programName,
        this.releaseEntity.programShortName,
        this.releaseEntity.releaseWithZero,
        this.releaseEntity.id,
        this.releaseEntity.contentSource
      );

      const tempPlaylist = new Playlist('', '', '');
      tempPlaylist.id = this.releaseEntity.videoDirectory;
      tempPlaylist.tracks = [video];

      await filesystemCustomUtils.cleanupPartialDownloads(tempPlaylist);
    },

    async removeSingleVideo(video: GoogleMedia) {
      if (!video) return;

      try {
        const fileName = this.releaseVideoStoredRelativePath(video);

        await Filesystem.deleteFile({
          path: `${this.releaseEntity.videoDirectory}/${fileName}`,
          directory: Directory.Data
        });

        this.offlineVideos.delete(video.id);
      } catch (error) {
        console.error('Failed to remove video', error);
      }
    },

    async checkOfflineByFileCount(entityType: string): Promise<boolean> {
      try {
        if (entityType === "video") {
          // Fetch video list if not already loaded
          if (this.videoList.length === 0) {
            await this.fetchVideoList();
          }

          let downloadedCount = 0;
          for (const video of this.videoList) {
            const rel = this.releaseVideoStoredRelativePath(video);
            try {
              const st = await Filesystem.stat({
                path: `${this.videoDirectory}/${rel}`,
                directory: Directory.Data,
              });
              if (st && st.size > 0) {
                downloadedCount++;
              }
            } catch {
              /* missing */
            }
          }
          
          // Mark as offline only if all videos are downloaded
          const allDownloaded = downloadedCount === this.videoList.length && this.videoList.length > 0;
          
          if (allDownloaded && !this.releaseEntity.videoOffline) {
            // All files downloaded but flag not set - update playlist and set flag
            const filesystemCustomUtils = new FilesystemCustomUtils();
            filesystemCustomUtils.setRelease(
              this.releaseEntity.programName,
              this.releaseEntity.programShortName,
              this.releaseEntity.releaseWithZero,
              this.releaseEntity.id,
              this.releaseEntity.contentSource
            );
            await filesystemCustomUtils.createOrUpdateVideoPlaylist(
              this.releaseEntity.videoDirectory,
              this.videoList,
              this.releaseEntity.programName,
              this.releaseEntity.programShortName,
              this.releaseEntity.releaseWithZero
            );
          }
          
          return allDownloaded;
        } else if (entityType === "music") {
          // Similar logic for music
          const musicDirPath = `${this.filesystemCustomUtils.PLAYLISTS_DIRECTORY}/${this.musicDirectory}`;
          const dirContent = await Filesystem.readdir({
            path: musicDirPath,
            directory: Directory.Data,
          });
          
          // Try to find playlist to get track count
          const foundPlaylist = dirContent.files.find((f) => {
            return f.name == this.filesystemCustomUtils.PLAYLIST_PATH;
          });
          
          if (foundPlaylist) {
            const res = await Filesystem.readFile({
              path: `${musicDirPath}/${this.filesystemCustomUtils.PLAYLIST_PATH}`,
              directory: Directory.Data,
              encoding: Encoding.UTF8,
            });
            const localPlaylist: Playlist = typeof res.data === 'string' ? JSON.parse(res.data) : null;
            
            if (localPlaylist && localPlaylist.tracks) {
              let downloadedCount = 0;
              for (const track of localPlaylist.tracks) {
                const fileExtension = this.mimeExtensions.get(track.mimeType || '') || 'mp3';
                const fileName = `${track.id}.${fileExtension}`;
                
                const fileExists = dirContent.files.some(f => 
                  f.name === fileName && !f.name.startsWith('dwn_') && f.size > 0
                );
                
                if (fileExists) {
                  downloadedCount++;
                }
              }
              
              return downloadedCount === localPlaylist.tracks.length && localPlaylist.tracks.length > 0;
            }
          }
        }
      } catch (error) {
        console.error(`Error checking offline status by file count for ${entityType}:`, error);
      }
      
      return false;
    },

    isOffline(entityType?: string) {
      if (!entityType || entityType == "music") {
        Filesystem.readdir({
          path: `${this.filesystemCustomUtils.PLAYLISTS_DIRECTORY}/${this.musicDirectory}`,
          directory: Directory.Data,
        })
          .then((musicDirContent) => {
            const foundPlaylist = musicDirContent.files.find((f) => {
              return f.name == this.filesystemCustomUtils.PLAYLIST_PATH;
            });

            if (typeof foundPlaylist !== "undefined" && null != foundPlaylist) {
              Filesystem.readFile({
                path: `${this.filesystemCustomUtils.PLAYLISTS_DIRECTORY}/${this.releaseEntity.musicDirectory}/${this.filesystemCustomUtils.PLAYLIST_PATH}`,
                directory: Directory.Data,
                encoding: Encoding.UTF8,
              })
                .then((res) => {
                  const localPlaylist: Playlist = typeof res.data === 'string' ? JSON.parse(res.data) : null;
                  if (localPlaylist) {
                    this.musicList = localPlaylist.tracks;

                    this.filesystemCustomUtils
                      .isPlaylistOffline(
                        this.filesystemCustomUtils.PLAYLISTS_DIRECTORY,
                        localPlaylist
                      )
                      .then((response) => {
                        this.releaseEntity.musicOffline = response;
                      }).catch((err) => {
                        console.error("Failed to load local music playlist", err);
                        this.releaseEntity.musicOffline = false;
                      });
                  }
                })
                .catch((err) => {
                  console.error("Failed to load local music playlist", err);
                  this.releaseEntity.musicOffline = false;
                });
            }
          })
          .catch(() => {
            this.releaseEntity.musicOffline = false;
          });
      }
      if (!entityType || entityType == "video") {
        Filesystem.readdir({
          path: this.videoDirectory,
          directory: Directory.Data,
        })
          .then((videoDirContent) => {
            const foundPlaylist = videoDirContent.files.find((f) => {
              return f.name == this.filesystemCustomUtils.PLAYLIST_PATH;
            });

            if (typeof foundPlaylist !== "undefined" && null != foundPlaylist) {
              Filesystem.readFile({
                path: `${this.videoDirectory}/${this.filesystemCustomUtils.PLAYLIST_PATH}`,
                directory: Directory.Data,
                encoding: Encoding.UTF8,
              })
                .then((res) => {
                  const localPlaylist: Playlist = typeof res.data === 'string' ? JSON.parse(res.data) : null;
                  if (localPlaylist) {
                    this.videoList = localPlaylist.tracks;

                    this.filesystemCustomUtils
                      .isPlaylistOffline("", localPlaylist)
                      .then((response) => {
                        // Only update if flag is not already set to true
                        // This prevents overwriting the flag after successful download
                        if (!this.releaseEntity.videoOffline || response) {
                          this.releaseEntity.videoOffline = response;
                          console.log(`Video offline status: ${response}`);
                        }
                      });
                  }
                })
                .catch((err) => {
                  console.error("Failed to load local video playlist", err);
                  this.releaseEntity.videoOffline = false;
                });
            } else {
              // No playlist.json found - check by file count
              // This handles case when files are downloaded but playlist wasn't created
              this.checkOfflineByFileCount('video').then(async (isOffline) => {
                if (isOffline) {
                  this.releaseEntity.videoOffline = true;
                } else {
                  // Even if not all files downloaded, check individual files for partial status
                  await this.checkVideoOfflineStatus();
                  this.releaseEntity.videoOffline = false;
                }
              }).catch(async () => {
                // Check individual files even on error
                await this.checkVideoOfflineStatus();
                this.releaseEntity.videoOffline = false;
              });
            }
          })
          .catch(() => {
            this.releaseEntity.videoOffline = false;
          });
      }
      if (!entityType || entityType == "guide") {
        Filesystem.readdir({
          path: this.guideDirectory,
          directory: Directory.Data,
        })
          .then((response) => {
            // Check if there are PNG files (guide pages) with size > 0
            const hasPages = response.files.some(f => 
              f.name.endsWith("png") && f.size > 0
            );
            this.releaseEntity.guideOffline = hasPages;
          })
          .catch(() => {
            this.releaseEntity.guideOffline = false;
          });
      }
    },

    removeReleaseEntityDirectory(entityType: string): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        const filesystemCustomUtils = new FilesystemCustomUtils();
        const entityProgressBar = this.downloadProgress.get(entityType);
        if (typeof entityProgressBar !== "undefined") {
          entityProgressBar.startDownload();
        }
        filesystemCustomUtils.setRelease(
          this.releaseEntity.programName,
          this.releaseEntity.programShortName,
          this.releaseEntity.releaseWithZero,
          this.releaseEntity.id,
          this.releaseEntity.contentSource
        );
        filesystemCustomUtils
          .removeReleaseEntityDirectory(entityType)
          .then((response) => {
            if (response) {
              if ("music" == entityType)
                this.releaseEntity.musicOffline = false;
              else if ("video" == entityType)
                this.releaseEntity.videoOffline = false;
              else if ("guide" == entityType)
                this.releaseEntity.guideOffline = false;
            }
            resolve(response);
          });
      });
    },

    async changeReleaseVisibility(value: boolean) {
      this.releaseVisible = value;

      if (this.isMobile) {
        const tokenQuery = await Preferences.get({ key: "jwt" });
        const token = tokenQuery.value;

        const options = {
          url: `${process.env.VUE_APP_API_URL}api/liga-releases/publish`,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          readTimeout: 60000,
          data: {
            id: this.releaseEntity.id,
            visible: value,
          },
        };

        await CapacitorHttp.post(options).catch(() => {
          this.$router.replace("/badconnection");
        });
      } else {
        axios
          .post("api/liga-releases/publish", {
            id: this.releaseEntity.id,
            visible: value,
          })
          .catch(() => {
            this.$router.replace("/badconnection");
          });
      }
    },

    async openReleaseSetting() {
      this.showReleaseSettings = true;

      if (this.releaseEntity.contentSource === 'SERVER') {
        return;
      }

      //get cache progress
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const audioOptions = {
        url: `${process.env.VUE_APP_API_URL}api/google/media/read-media-cache-progress`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
        params: {
          progressId: this.releaseEntity.musicDirectory,
        },
      };

      CapacitorHttp.get(audioOptions).then((result) => {
        if (result.data && !isNaN(result.data)) {
          const progressBar =
            this.cacheReloadProgress.get("music") || new MediaProgressBar();
          progressBar.id = this.releaseEntity.musicDirectory;
          progressBar.currentValue = Number(result.data.progressValue);
          progressBar.maxValue = Number(result.data.progressMaxValue);
        }
      });

      const videoOptions = {
        url: `${process.env.VUE_APP_API_URL}api/google/media/read-media-cache-progress`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
        params: {
          progressId: this.releaseEntity.videoDirectory,
        },
      };

      CapacitorHttp.get(videoOptions).then((result) => {
        if (result.data && !isNaN(result.data)) {
          const progressBar =
            this.cacheReloadProgress.get("video") || new MediaProgressBar();
          progressBar.id = this.releaseEntity.videoDirectory;
          progressBar.currentValue = Number(result.data.progressValue);
          progressBar.maxValue = Number(result.data.progressMaxValue);
        }
      });
    },

    async reloadAudioCache() {
      if (this.releaseEntity.contentSource === 'SERVER') {
        return;
      }

      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/google/media/${this.releaseEntity.musicDirectory}`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      const mediaType = "music";
      const progressBar =
        this.cacheReloadProgress.get(mediaType) || new MediaProgressBar();
      progressBar.id = this.releaseEntity.musicDirectory;
      progressBar.currentValue = 0;

      await CapacitorHttp.get(options).then((response) => {
        this.musicList = response.data;
        progressBar.maxValue = this.musicList.length - 1;
        this.reloadCacheRequest(
          token || "",
          this.getCacheFileName(progressBar.currentValue, mediaType),
          mediaType
        );
      });
    },

    async reloadVideoCache() {
      if (this.releaseEntity.contentSource === 'SERVER') {
        return;
      }

      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/google/media/${this.releaseEntity.videoDirectory}`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      const mediaType = "video";
      const progressBar =
        this.cacheReloadProgress.get(mediaType) || new MediaProgressBar();
      progressBar.id = this.releaseEntity.videoDirectory;
      progressBar.currentValue = 0;

      await CapacitorHttp.get(options).then((response) => {
        this.videoList = response.data;
        progressBar.maxValue = this.videoList.length - 1;

        this.reloadCacheRequest(
          token || "",
          this.getCacheFileName(progressBar.currentValue, mediaType),
          mediaType
        );
      });
    },

    getCacheFileName(index: number, mediaType: string): string {
      try {
        if ("music" === mediaType) {
          return `${this.musicList[index].id}.mp3`;
        } else if ("video" === mediaType) {
          return `${this.videoList[index].id}`;
        } else return "";
      } catch (ex) {
        return "";
      }
    },

    reloadCacheRequest(token: string, fileName: string, mediaType: string) {
      const progressBar =
        this.cacheReloadProgress.get(mediaType) || new MediaProgressBar();
      progressBar.downloading =
        progressBar.currentValue <= progressBar.maxValue;

      if (progressBar.downloading) {
        CapacitorHttp.get({
          url: `${process.env.VUE_APP_API_URL}api/google/reload-media-cache`,
          headers: { Authorization: `Bearer ${token}` },
          params: {
            fileName: fileName,
            mediaType: mediaType,
            progressId: String(progressBar.id),
            progressValue: String(progressBar.currentValue),
            progressMaxValue: String(progressBar.maxValue),
          },
          readTimeout: 60000,
        })
          .then(() => {
            progressBar.currentValue = progressBar.currentValue + 1;
            this.reloadCacheRequest(
              token || "",
              this.getCacheFileName(progressBar.currentValue, mediaType),
              mediaType
            );
          })
          .catch(() => {
            console.error("Error reloading media cache");
            progressBar.currentValue = progressBar.maxValue;
            progressBar.downloading = false;
          });
      } else {
        CapacitorHttp.get({
          url: `${process.env.VUE_APP_API_URL}api/google/clear-media-cache-progress`,
          headers: { Authorization: `Bearer ${token}` },
          params: {
            progressId: String(progressBar.id),
          },
          readTimeout: 60000,
        });
      }
    },
  },
});
</script>

<style scoped>
.top-safe-area {
  width: 100vw;
  height: var(--ion-safe-area-top);
}

.logo {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.logo img {
  width: 220px;
  padding-top: 5vh;
  scale: 0.8;
  margin-bottom: 1vh;
}

.page-content {
  position: relative;
  padding-bottom: 20px;
}

.release-page-container {
  width: 100%;
  position: relative;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.release-page-background {
  width: 100%;
  padding-left: 2vw;
  padding-right: 2vw;
  position: relative;
  margin-top: 20px;
  max-height: 70%;
  min-height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.release-page-background img {
  border-radius: 15px;
  max-height: 70vh;
  max-width: 100%;
  height: auto;
  width: auto;
  object-fit: contain;
}

.release-info-container {
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 10;
  padding: 0 20px;
}

.release-program-name {
  color: white;
  font-size: 1.8em;
  font-weight: 600;
  text-align: center;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
  letter-spacing: 0.05em;
}

.release-number {
  color: var(--ion-color-orange);
  font-size: 1.2em;
  font-weight: 500;
  text-align: center;
  text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.8);
  letter-spacing: 0.1em;
}

.media-buttons {
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 30%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  z-index: 10;
}

.media-button {
  color: white;
  --border-radius: 50%;
  --border-style: solid;
  --border-width: 3px;
  --border-color: var(--ion-color-orange);
  --color-activated: var(--ion-color-orange-tint);
  --background-hover-opacity: 0;
  --background-activated: transparent;
  --background-activated-opacity: 0;
  --background-focused: transparent;
  --background: rgba(32, 33, 75, 0.7);
  height: 10vh;
  width: 10vh;
}

.media-button ion-icon {
  font-size: 2em;
}

.media-button-middle {
  margin-left: 4vh;
  margin-right: 4vh;
}

.bottom-buttons-container {
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 5%;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
}

.download-button {
  color: white;
  --background: rgba(40, 40, 40, 0.7);
  --border-color: var(--ion-color-orange);
  --border-style: solid;
  --border-width: 1px;
  --color-activated: var(--ion-color-orange-tint);
  --background-activated: transparent;
  --background-activated-opacity: 0;
  max-width: 80%;
  letter-spacing: 0.15em;
}

.download-button ion-label {
  font-size: 1em;
  text-transform: none !important;
}

.admin-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.admin-buttons ion-label {
  margin-top: 2.5px;
}

.bottom-buttons-container-landscape {
  position: absolute;
  left: 80% !important;
  top: 0 !important;
  bottom: unset !important;
}

.admin-buttons-landscape {
  flex-flow: column;
}

.release-settings-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
  --backdrop-opacity: 0.3;
}

.release-settings-card-container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-flow: column;
  height: 100vh;
}

.release-settings-card-container ion-card {
  padding: 20px;
  max-height: 90%;
  overflow: scroll;
  --background: #1f1f1f !important;
}

.release-settings-card-container ion-card-title {
  color: white;
  font-weight: bold;
  font-size: 1.8em;
  letter-spacing: 0.07em;
}

.release-settings-card-container ion-card-content {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 0.07em;
}

.release-settings-card-container ion-item {
  --background: transparent !important;
  color: white !important;
}

.release-settings-card-container ion-item ion-icon {
  color: white !important;
  cursor: pointer;
}

.release-settings-btn-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.release-settings-btn-container ion-button {
  --background: transparent;
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
  --border-color: var(--ion-color-orange) !important;
  --border-style: solid !important;
  --border-width: 1px !important;
}

.download-remaining-button {
  --background: var(--ion-color-orange) !important;
  --background-activated: var(--ion-color-orange-tint) !important;
  --color: white !important;
  --border-color: var(--ion-color-orange) !important;
}

.info-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.8em;
}

.offline-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  background-color: rgba(31, 31, 31, .8);
}

.video-details-content {
  background-color: rgba(45, 52, 54, 0.8);
  padding: 8px 0;
}

.video-detail-item {
  padding-left: 48px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 48px;
}

.video-detail-item:last-child {
  border-bottom: none;
}

.video-name {
  font-size: 0.9em;
  font-weight: 500;
}

.video-status {
  font-size: 0.75em;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 2px;
}

.video-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.video-icon {
  font-size: 1.2em;
  color: var(--ion-color-orange);
  cursor: pointer;
  transition: transform 0.2s;
}

.video-icon:hover {
  transform: scale(1.1);
}

/* Video Download Modal Styles */
.video-download-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
  --backdrop-opacity: 0.3;
}

.video-select-modal {
  --background: rgba(67, 67, 67, 0.5) !important;
  --backdrop-opacity: 0.3;
}

.video-select-content {
  max-height: 50vh;
  overflow-y: auto;
}

.video-select-content ion-list {
  background-color: transparent !important;
  padding: 0;
}

.video-select-item {
  --background: #2a2a2a !important;
  background-color: #2a2a2a !important;
  color: white !important;
  border-bottom: none;
  margin-bottom: 0;
  border-radius: 0;
}

.video-select-item h2 {
  font-size: 0.95em;
  font-weight: 500;
  margin-bottom: 4px;
}

.video-select-item p {
  font-size: 0.8em;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.video-status-hint {
  font-size: 0.7em !important;
  color: rgba(255, 255, 255, 0.4) !important;
  font-style: italic;
  margin-top: 2px !important;
}

.downloading-item {
  opacity: 0.7;
  background-color: rgba(255, 165, 0, 0.1) !important;
}

.video-select-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.video-select-icon {
  font-size: 1.3em;
  color: var(--ion-color-orange);
  cursor: pointer;
  transition: transform 0.2s;
}

.video-select-icon:hover {
  transform: scale(1.1);
}

.offline-select-container {
  background-color: #2d3436;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  width: 100%;
  height: auto;
  z-index: 11000;
}

.offline-select-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  z-index: 11000;
}

.offline-select-header {
  background-color: #2d3436;
}

.close-icon {
  font-size: 24px;
  color: var(--ion-color-orange);
  transition: color 0.3s;
  z-index: 11000;
}

.close-icon:hover {
  color: var(--ion-color-orange);
}

ion-list {
  background-color: #2d3436;
  z-index: 11000;
}

ion-list-header {
  font-size: 18px;
  font-weight: bold;
  color: white;
  margin: 12px 0;
  letter-spacing: .08em;
  border-bottom: 1px solid rgba(255, 255, 255, .5);
  z-index: 11000;
}

.offline-progress {
  height: 6px;
  background-color: #4caf50;
  border-radius: 3px;
  transition: width 0.4s ease;
  z-index: 11000;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 20%;
}

.offline-progress-container {
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  height: 4px;
  z-index: 11001;
  pointer-events: none;
}

.offline-progress-bottom {
  height: 4px;
  background-color: #4caf50;
  border-radius: 2px;
  transition: width 0.4s ease;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  z-index: 11002;
  pointer-events: none;
}

.offline-progress-text {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 9px;
  color: white;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9), 0 0 2px rgba(0, 0, 0, 0.9);
  white-space: nowrap;
  z-index: 11003;
  line-height: 4px;
  padding: 2px 4px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  pointer-events: none;
}

.single-video-progress-container {
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  height: 3px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
  z-index: 11001;
}

.single-video-progress-bar {
  height: 100%;
  background-color: #4caf50;
  border-radius: 2px;
  transition: width 0.3s ease;
  width: 0;
}

ion-item {
  background-color: #212121;
  --background: transparent !important;
  padding: 12px 16px;
  padding-bottom: 16px;
  border-radius: 6px;
  margin: 10px 0;
  transition: background 0.3s;
  z-index: 11000;
  position: relative;
  overflow: visible;
}

ion-item:hover {
  background-color: #545454;
}

ion-icon {
  font-size: 20px;
  color: var(--ion-color-orange);
  transition: color 0.3s;
  cursor: pointer;
  z-index: 11000;
}

ion-icon:hover {
  color: var(--ion-color-orange);
}

.online-item {
  color: var(--ion-color-orange);
  z-index: 11000;
}

.offline-item {
  color: #4caf50;
  font-weight: bold;
  letter-spacing: .08em;
  z-index: 11000;
}

/* Адаптивные стили для информации о релизе */
@media (max-width: 768px) {
  .release-program-name {
    font-size: 1.5em;
  }
  
  .release-number {
    font-size: 1em;
  }
}

@media (max-width: 480px) {
  .release-info-container {
    bottom: 50%;
    gap: 6px;
  }
  
  .release-program-name {
    font-size: 1.3em;
  }
  
  .release-number {
    font-size: 0.95em;
  }
}

/* Ландшафтная ориентация */
@media (orientation: landscape) and (max-height: 600px) {
  .release-info-container {
    bottom: 40%;
    gap: 4px;
  }
  
  .release-program-name {
    font-size: 1.2em;
  }
  
  .release-number {
    font-size: 0.9em;
  }
}
</style>